module.exports = {
	"elementName": "ObjectSchema",
	"name": "TextParagraph",
	"containers": [
		{
			"name": "container",
			"elementName": "Container",
			"style": {
				"top": 0,
				"left": 0,
				"width": 356,
				"height": 668,
				"position": "relative"
			},
			"props": {
				"startOnNewPage": false,
				"unbreakable": false
			},
			"boxes": [
				{
					"name": "arial",
					"elementName": "Core.HtmlBox",
					"style": {
						"top": 0,
						"left": 0,
						"width": 350,
						"height": 150,
						"transform": {}
					},
					"props": {
						"content": "<p><strong>Arial</strong></p>\n<p>Arial is an extremely versatile family of typefaces which can be used with equal success for text setting in reports, presentations, magazines etc, and for display use in newspapers, advertising and promotions.</p>"
					}
				},
				{
					"name": "verdana",
					"elementName": "Core.HtmlBox",
					"style": {
						"top": 150,
						"left": 0,
						"width": 350,
						"height": 150,
						"transform": {}
					},
					"props": {
						"content": "<p><strong>Verdana</strong></p>\n<p>The Verdana typeface family was designed specifically to address the challenges of on-screen display. These sans serif fonts are unique examples of type design for the computer screen.</p>",
						"font": {
							"fontFamily": "Verdana"
						}
					}
				},
				{
					"name": "helvetica",
					"elementName": "Core.HtmlBox",
					"style": {
						"top": 300,
						"left": -1,
						"width": 350,
						"height": 100,
						"transform": {}
					},
					"props": {
						"content": "<p><strong>Helvetica</strong></p>\n<p>Helvetica is an easy to read font, with tall and narow letters, that works well on almost every site.</p>",
						"font": {
							"fontFamily": "Helvetica"
						}
					}
				},
				{
					"name": "timesNewRoman",
					"elementName": "Core.HtmlBox",
					"style": {
						"top": 400,
						"left": 0,
						"width": 350,
						"transform": {}
					},
					"props": {
						"content": "<p><strong>Times New Roman</strong></p>\n<p>Widely used in books and magazines, for reports, office documents and also for display and advertising.</p>",
						"font": {
							"fontFamily": "Times New Roman"
						}
					}
				},
				{
					"name": "courierNew",
					"elementName": "Core.HtmlBox",
					"style": {
						"top": 500,
						"left": 0,
						"width": 350,
						"height": 160,
						"transform": {}
					},
					"props": {
						"content": "<p><strong>Courier&nbsp;New</strong></p>\n<p>A typical fixed pitch design, monotone in weight and slab serif in concept. Used to emulate typewriter output for reports, tabular work and technical documentation. It's great for storytelling, narratives and news reporting.</p>",
						"font": {
							"fontFamily": "Courier New"
						}
					}
				}
			],
			"containers": []
		}
	],
	"data": {},
	"props": {
		"context": {}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/TextParagraph.json
 ** module id = 970
 ** module chunks = 0
 **/